export default __webpack_public_path__ + "static/media/digital prize wheel.32dafc2b.wav";